import React from 'react';
import { IPagination } from '../interface/ICommon';
import { PaginationMobile } from './PaginationMobile';
import { PaginationPc } from './PaginationPc';

export const Pagination = ({ dat }: { dat: IPagination | undefined }) => {
    if (!dat || dat.lastPage < 2) {
        return null;
    }

    return (
        <>
            <PaginationPc dat={dat} />
            <PaginationMobile dat={dat} />
        </>
    );
};
